import apiClient from './apiClient';
import { clearSeoCache } from './seoPublicService';

export async function getAdminSeoSettings() {
  const response = await apiClient.get('/api/admin/seo');
  return response.data;
}

export async function saveGlobalSeo(payload) {
  const response = await apiClient.patch('/api/admin/seo/global', payload);
  clearSeoCache();
  return response.data;
}

export async function savePageSeo(payload) {
  const response = await apiClient.put('/api/admin/seo/pages', payload);
  clearSeoCache();
  return response.data;
}

export async function deletePageSeo(pageKey) {
  const response = await apiClient.delete(`/api/admin/seo/pages/${pageKey}`);
  clearSeoCache();
  return response.data;
}

export async function saveRobotsSettings(payload) {
  const response = await apiClient.patch('/api/admin/seo/robots', payload);
  return response.data;
}

export async function regenerateSitemap() {
  const response = await apiClient.post('/api/admin/seo/sitemap/regenerate');
  return response.data;
}
